import React from 'react'
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';
const OrderDetail = ({ MealData, i18n }) => {
  return (
    <div className='order-detail'>
      <h3>Order Details</h3>
      <div className='items-header'> {i18n.t('items')} </div>
      <div className='order-detail-content'>
        {MealData?.map((meal) => {
          return <div className='order-card'>
            <Icon source={MobileCancelMajor} color="base" />
            <img src={meal?.imgUrl} className='order-img' />
            <div className='order-name'>
              {meal?.name}
            </div>
            <div className='order_quantity'>
              {meal?.quantity}
            </div>
          </div>
        })}
      </div>
    </div>
  );
}

export default OrderDetail;
